(() => {
  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'INR';
    const locale = document.documentElement.lang || 'en-IN';
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
  };

  const initialise = (form) => {
    if (form.dataset.variantOptionsInitialised === 'true') return;
    form.dataset.variantOptionsInitialised = 'true';

    const optionSelects = [...form.querySelectorAll('[data-product-option]')];
    if (!optionSelects.length) return;

    const variantInput = form.querySelector('[data-selected-variant-id]');
    const variantsNode = form.querySelector('[data-variants-json]');
    const addButton = form.querySelector('[name="add"]');
    const price = document.querySelector('[data-product-price]');
    let variants = [];

    try {
      variants = JSON.parse(variantsNode?.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const update = () => {
      const selectedOptions = optionSelects.map((select) => select.value);
      const variant = variants.find((item) =>
        selectedOptions.every((value, index) => item.options?.[index] === value)
      );

      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          const label = addButton.querySelector('span');
          if (label) label.textContent = 'Unavailable';
        }
        return;
      }

      variantInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (addButton) {
        addButton.disabled = !variant.available;
        const label = addButton.querySelector('span');
        if (label) {
          label.textContent = variant.available
            ? (addButton.dataset.addText || 'Add to cart')
            : (addButton.dataset.soldText || 'Sold out');
        }
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      form.dispatchEvent(new CustomEvent('variant:change', { detail: { variant } }));
    };

    optionSelects.forEach((select) => select.addEventListener('change', update));
    update();
  };

  const boot = () => document.querySelectorAll('[data-product-form]').forEach(initialise);
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
